package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.task.domain.model.TaskModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun TaskStatusDropDown(
    status: TaskModel.Status?,
    onStatusSelected: (TaskModel.Status) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }

    Box(modifier = modifier) {
        TaskStatus(
            status = status,
            suffixIconRes = if (isExpanded) EsIcons.ArrowUp else EsIcons.ArrowDown,
            modifier = Modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable {
                    if (enabled)
                        isExpanded = true
                },
        )

        EsDropDownMenu(
            expanded = isExpanded,
            onDismissRequest = { isExpanded = false },
            paddingValues = PaddingValues(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            TaskModel.Status.entries.forEach { status ->
                TaskStatus(
                    status = status,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            onStatusSelected(status)
                            isExpanded = false
                        },
                )
            }
        }
    }
}